import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  ksfExcessTab,
  UpdateKsfTemplate,
} from 'projects/shared/src/lib/models/ksf.model';
import {
  DmrResponse,
  LibUtilityService,
  PriceTagInfo,
} from 'projects/shared/src/public-api';

@Component({
    selector: 'lib-ksf-price-card',
    templateUrl: './ksf-price-card.component.html',
    styleUrls: ['./ksf-price-card.component.scss'],
    standalone: false
})
export class KsfPriceCardComponent {
  // Event emitted to the parent component
  @Output() pickKsfEvent = new EventEmitter();
  @Output() recalculateKsfPricesEvent = new EventEmitter();
  @Output() setKsfTemplateEvent = new EventEmitter<UpdateKsfTemplate>();
  @Output() setKsfExcessTabEvent = new EventEmitter<ksfExcessTab>();

  // Input properties to receive data from the parent component
  @Input() errorIngetInsurancePrices: boolean = false;
  @Input() errorInKSFPrice: boolean = false;
  @Input() allHaveTogglePricetag: boolean = false;
  @Input() ksfPriceLoading: boolean = false;
  @Input() showYearlyPrice: boolean = false;
  @Input() ksfPrice: number = 0;
  @Input() vehicleFromDmr: DmrResponse = {} as DmrResponse;
  @Input() ksfExcessTab: ksfExcessTab = {
    value: 0,
    valueText: '',
  };
  @Input() ksfPriceResult: any; // make interface
  @Input() ksfTemplate: UpdateKsfTemplate = {} as UpdateKsfTemplate;

  // Internal state variables
  openKsfPricetag: boolean = false;
  showTooltip_ksfPrice: boolean = false;

  constructor(private libUtilityService: LibUtilityService) {}

  /**
   * Retrieve the price tag information for the KSF insurance.
   * Sends the price tag information to the utility service for retrieval.
   * @returns void
   */
  getKsfPriceTag(): void {
    const priceTagInfo: PriceTagInfo = {
      insuranceCompanyId: 3,
      vehicleMake: this.vehicleFromDmr.make,
      vehicleModel: this.vehicleFromDmr.model,
      monthlyPrice: Math.round(this.ksfPrice / 12),
      yearlyPrice: Math.round(this.ksfPrice),
      excessPrice: +this.ksfExcessTab.valueText,
    };
    this.libUtilityService.getPriceTag(priceTagInfo);
  }

  /**
   * Download the price tag for the KSF insurance.
   * Sends the price tag information to the utility service to generate a PDF file.
   * @returns void
   */
  downloadKsfPriceTag(): void {
    const priceTagInfo: PriceTagInfo = {
      insuranceCompanyId: 3,
      vehicleMake: this.vehicleFromDmr.make,
      vehicleModel: this.vehicleFromDmr.model,
      monthlyPrice: Math.round(this.ksfPrice / 12),
      yearlyPrice: Math.round(this.ksfPrice),
      excessPrice: +this.ksfExcessTab.valueText,
    };

    this.libUtilityService.downloadPriceTag(priceTagInfo, 'ksf-prisskilt.pdf');
  }

  /**
   * Emit an event indicating that the KSF price has been selected.
   * @returns void
   */
  pickKsfPrice(): void {
    //this.pickKsfEvent.emit();
    this.pickKsfEvent.emit(true);
  }

  /**
   * Emit an event to trigger the recalculation of KSF insurance prices.
   * @returns void
   */
  recalculate() {
    this.recalculateKsfPricesEvent.emit();
  }

  /**
   * Calculate the index of the current excess tab in the KSF price result.
   * @returns number - The index of the current excess tab, or 0 if not found or in case of error.
   */
  calculateTabIndex(): number {
    if (!this.ksfPriceResult.error) {
      if (this.ksfPriceResult.deductibles.length > 0) {
        return this.ksfPriceResult.deductibles[0].type.selectList.findIndex(
          (tab: any) => tab.value === this.ksfExcessTab.value,
        );
      }
    }
    return 0;
  }

  /**
   * Handle changes to the KSF excess tab selection.
   * Emits events to update the excess tab and template.
   * @param event - The event object containing the new tab index.
   * @returns void
   */
  ksfExcessTabChange(event: any) {
    const stepIndex = event.target.value;
    this.ksfExcessTab =
      this.ksfPriceResult.deductibles[0].type.selectList[stepIndex];

    // Update deductible values in the KSF template
    this.ksfTemplate.deductibles.forEach((deductible) => {
      deductible.Value = this.ksfExcessTab.value;
    });

    // Emit events to notify other components or services of the updated excess tab and template
    this.setKsfExcessTabEvent.emit(this.ksfExcessTab);
    this.setKsfTemplateEvent.emit(this.ksfTemplate);
  }
}
